export class CreateProjectRequest {

    constructor(
        organizationDetails,
        projectProperties,
        userProperties,
        entities,
        relations
    ) {
        this.organizationDetails = organizationDetails;
        this.projectProperties = projectProperties;
        this.userProperties = userProperties;
        this.entities = entities;
        this.relations = relations;
    }
}